const WalletType = {
  ACCEPTANCE_SLA_BREACH: 1,
  ASSIGNMENT_SLA_BREACH: 2,
  ARRIVAL_SLA_BREACH: 3,
  INDENT_REJECT: 4,
  REINDENT: 5,
  RFQ_REINDENT: 6,
  RECONCILE_INVOICE: 7,
};

const reconcilePrefix = 'RECONCILE-';

const WalletConstants = {
  Status: {
    UNUSED: 1,
    USED: 2,
    CANCELLED: 3,
    REASSIGNED: 4,
  },
  StatusType: {
    1: 'UNUSED',
    2: 'USED',
    3: 'CANCELLED',
    4: 'REASSIGNED',
  },
  WalletType: {
    ACCEPTANCE_SLA_BREACH: 1,
    ASSIGNMENT_SLA_BREACH: 2,
    ARRIVAL_SLA_BREACH: 3,
    INDENT_REJECT: 4,
    REINDENT: 5,
    RFQ_REINDENT: 6,
    RECONCILE_INVOICE: 7,
  },
  WalletTypeForExcel: {
    1: 'ACCEPTANCE - SLA BREACH',
    2: 'ASSIGNMENT - SLA BREACH',
    3: 'ARRIVAL - SLA BREACH',
    4: 'INDENT REJECT',
    5: 'REINDENT',
    6: 'RFQ REINDENT',
    7: 'RECONCILED',
  },
  DefaultAmount: 20,
  IndentCleanType: {
    unloading_detention_charge: 1,
    loading_detention_charge: 2,
    transit_charge: 3,
    shortage_charge: 4,
    damage_charge: 5,
    leakage_charge: 6,
    carton_damage_charge: 7,
    additionalPoint: 8,
    slaDelay: 9,
    cartonDamage: 10,
    freight: 11,
    damage: 12,
    loading: 13,
    loadingDetention: 14,
    lr: 15,
    oda: 16,
    shortage: 17,
    transitDelay: 18,
    unloading: 19,
    unloadingDetention: 20,
  },
  invoiceFields: [
    'total_amount',
    'contract_charge',
    'loading_detention_charge',
    'transit_charge',
    'lr_charge',
    'arrival_charge',
    'loading_charge',
    'unloading_charge',
    'shortage_charge',
    'damage_charge',
    'leakage_charge',
    'oda_charges',
    'additional_point_charges',
    'extra_charges',
    'carton_damage_charge',
  ],
};

module.exports = { WalletType, reconcilePrefix, WalletConstants };
